// ⚠️ 此文件由 api:gen 自动生成，请勿手动修改
// 源: capabilities/questionnaire.yaml
// 生成时间: 2026-08-28T07:23:51.318Z
import http from '../http';

export default {
  // 获取列表 questionnaire.getlistUrl
  getlistUrl: (data) => http.post('/formbuilder/form/page', data),

  // 添加和更新 questionnaire.addorUpdateUrl
  addorUpdateUrl: (data) => http.post('formbuilder/form/save', data),

  // 获取单个问卷 questionnaire.getnaireUrl
  getnaireUrl: (data) => http.post('formbuilder/form/get', data),

  // 删除 questionnaire.deleteUrl
  deleteUrl: (data) => http.post('formbuilder/form/delete', data),

  // 导出收集的数据 questionnaire.exportUrl
  exportUrl: (data) => http.post('formbuilder/userform/export', data),

  // 导出收集的数据 questionnaire.exportHasNumUrl
  exportHasNumUrl: (data) => http.post('formbuilder/userform/export/with', data),

  // 获取报表信息 questionnaire.reportCount
  reportCount: (data) => http.post('formbuilder/form/count', data),

  // 获取报表的文本类答案 questionnaire.reportInputData
  reportInputData: (data) => http.post('formbuilder/form/pageAnswer', data),

  // 获取报表类的数据 questionnaire.reportList
  reportList: (data) => http.post('formbuilder/userform/pagedetail', data),

  // 批量导出 questionnaire.batchexport
  batchexport: (data) => http.post('formbuilder/userform/batchexport', data),
};
